'use client';

import { HOMEPAGE_FILTER_TRACKING } from '@/src/components/ListingSearch/filterAnalytics';
import type { AreaResponse } from '@/src/lib/api';
import { ListingSearchControls } from '@/src/components/ListingSearch/ListingSearch';
import { SearchFiltersProvider } from '@/src/components/ListingSearch/SearchFiltersProvider';
import { DEFAULT_FILTERS, type FilterState } from '@/src/lib/filters/filterTypes';

// A recent search, when there is one, still replaces this default.
const HOMEPAGE_DEFAULT_FILTERS: FilterState = { ...DEFAULT_FILTERS, propertyTypes: ['apartment'] };

type HomepageListingSearchesProps = {
  initialArea?: AreaResponse | null;
  mobileClassName: string;
  desktopClassName: string;
};

export function HomepageListingSearches({
  initialArea,
  mobileClassName,
  desktopClassName,
}: HomepageListingSearchesProps) {
  return (
    <SearchFiltersProvider
      trackingContext={HOMEPAGE_FILTER_TRACKING}
      mode="navigate"
      fallbackArea={initialArea}
      seedFromRecentSearch
      defaultFilters={HOMEPAGE_DEFAULT_FILTERS}
    >
      <div className={mobileClassName}>
        <ListingSearchControls size="lg" testIdSuffix="mobile" />
      </div>

      <div className={desktopClassName}>
        <ListingSearchControls size="lg" testIdSuffix="desktop" />
      </div>
    </SearchFiltersProvider>
  );
}
